
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Stethoscope, Heart, UserCircle } from "lucide-react";

interface RoleSelectionProps {
  onRoleSelect: (role: "doctor" | "patient") => void;
}

export function RoleSelection({ onRoleSelect }: RoleSelectionProps) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 to-teal-100 flex items-center justify-center p-4">
      <Card className="w-full max-w-2xl mx-auto">
        <CardHeader className="text-center">
          <div className="w-16 h-16 bg-emerald-600 rounded-full flex items-center justify-center mx-auto mb-4">
            <UserCircle className="w-8 h-8 text-white" />
          </div>
          <CardTitle className="text-3xl">Welcome to ClinicaFlow</CardTitle>
          <CardDescription className="text-lg">Choose how you'd like to access the platform</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <Card 
              className="cursor-pointer hover:shadow-lg transition-shadow border-2 hover:border-emerald-500"
              onClick={() => onRoleSelect("doctor")}
            >
              <CardContent className="p-8 text-center">
                <div className="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Stethoscope className="w-10 h-10 text-emerald-600" />
                </div>
                <h3 className="text-xl font-semibold mb-2">Healthcare Provider</h3>
                <p className="text-gray-600 mb-4">
                  Access your practice management tools, patient schedules, and clinical workflows
                </p>
                <Button className="w-full bg-emerald-600 hover:bg-emerald-700">Continue as Provider</Button>
              </CardContent>
            </Card>

            <Card 
              className="cursor-pointer hover:shadow-lg transition-shadow border-2 hover:border-teal-500"
              onClick={() => onRoleSelect("patient")}
            >
              <CardContent className="p-8 text-center">
                <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Heart className="w-10 h-10 text-teal-600" />
                </div>
                <h3 className="text-xl font-semibold mb-2">Patient</h3>
                <p className="text-gray-600 mb-4">
                  Book appointments, access your medical records, and manage your healthcare
                </p>
                <Button variant="outline" className="w-full border-teal-500 text-teal-600 hover:bg-teal-50">
                  Continue as Patient
                </Button>
              </CardContent>
            </Card>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
